__turbopack_context__.v({
  "actions": "lnUIdW_actions",
  "active": "lnUIdW_active",
  "dashboardLink": "lnUIdW_dashboardLink",
  "divider": "lnUIdW_divider",
  "header": "lnUIdW_header",
  "headerWrapper": "lnUIdW_headerWrapper",
  "hovered": "lnUIdW_hovered",
  "loginLink": "lnUIdW_loginLink",
  "logo": "lnUIdW_logo",
  "logoLink": "lnUIdW_logoLink",
  "logoLinkDesktop": "lnUIdW_logoLinkDesktop",
  "logoLinkMobile": "lnUIdW_logoLinkMobile",
  "nav": "lnUIdW_nav",
  "navGroup": "lnUIdW_navGroup",
  "navLink": "lnUIdW_navLink",
  "scrolled": "lnUIdW_scrolled",
  "signInLink": "lnUIdW_signInLink",
});
